import type { FunctionComponent } from 'react';

import { GuideCard } from '@/domains/digitalAdvice/GuideCard/GuideCard.lazy';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';

export interface AdviceBlockProps {
  className?: string;
}

export const AdviceBlock: FunctionComponent<AdviceBlockProps> = ({
  className,
}) => {
  const { tipsheet } = useDetail<'b2c'>();

  if (tipsheet) {
    return (
      <div className={className}>
        <GuideCard {...tipsheet} />
      </div>
    );
  }

  return null;
};
